import {Injectable} from '@angular/core';
import {LoanApplicationDocumentType} from '../model/loan-application-document-type.model';
import {UserDocumentService} from '../service/user-document.service';
import {AddressProofType} from '../model/address-proof-type.model';
import {UserDocument} from '../model/user-document.model';

@Injectable()
export class UserDocumentInteractor {
    private readonly userDocumentService: UserDocumentService;

    constructor(userDocumentService: UserDocumentService) {
        this.userDocumentService = userDocumentService;
    }
    public async create(type: LoanApplicationDocumentType | AddressProofType, fileIds: string[]) {
        return await this.userDocumentService.create(type, fileIds);
    }

    public async getById(documentId: string): Promise<UserDocument> {
        return await this.userDocumentService.getByDocumentId(documentId);
    }
}
